export const SHOP_LIST = 'cdb/shop/listnear'
export const QR_CODE = 'cdb/cabinet/checkisok'
export const ZH_CODE = 'cdb/cabinet/zhorder'

export const ORDER_TEMP = 'cdb/cabinet/createorder'
export const ORDER_CZ = 'cdb/cabinet/order'
export const ORDER_CHECK = 'cdb/cabinet/ordercheck'
export const ORDER_PAYU = '/cdb/payment/payU/multiCurrency/createOrder'
export const ORDER_GOPAY = '/cdb/payment/goPay/multiCurrency/createOrder'
export const ORDER_PAYU_CONFIRM = '/cdb/payment/payU/multiCurrency/authConfirm/payment'
export const ORDER_GOPAY_CONFIRM = '/cdb/payment/goPay/multiCurrency/authConfirm/payment'
export const PAY_ORDER_GOPAY = '/cdb/payment/goPay/multiCurrency/payOrder'
